import React from 'react';
import { ArrowUpRightIcon, MessageCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const ROUTINE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/26dbfa4a-7ba3-4b9d-b1d3-558d478cf450.jpg';
export function FinalSection() {
  return <section aria-labelledby="y-ahora-que-sigue" className="bg-warmwhite px-6 py-28 sm:px-10 sm:py-40" data-id="element-47" data-mp="332fg4psia0ov">
      <div className="mx-auto max-w-6xl" data-id="element-48" data-mp="2od16rhoxjj9h">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-20" data-id="element-49" data-mp="2obzwhffqn0st">
          <div className="lg:col-span-5" data-id="element-50" data-mp="2t4j6k2f7vdsv">
            <Reveal delay={0.05} data-id="element-51" data-mp="2t5kjydjpgcdr">
              <h2 id="y-ahora-que-sigue" className="font-serif text-[2.1rem] font-light leading-[1.15] tracking-[-0.015em] text-ink-900 sm:text-[3rem]" data-id="element-52" data-mp="2fd4mds9kp6k8">
                ¿Y ahora qué sigue?
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-7" data-id="element-53" data-mp="2adrzx8mm61i6">
            <div className="max-w-reading space-y-7 font-sans text-[1rem] font-light leading-[1.95] text-ink-500 sm:text-[1.05rem]" data-id="element-54" data-mp="2acqgafrj86ou">
              <Reveal delay={0.08} data-id="element-55" data-mp="2wg7q4gn6db8b">
                <p className="font-serif text-[1.35rem] leading-[1.6] text-ink-900 sm:text-[1.6rem]" data-id="element-56" data-mp="2rfjpd3959g0w">
                  Ahora ya entendés por qué muchas rutinas no funcionan.
                </p>
              </Reveal>
              <Reveal delay={0.12} data-id="element-57" data-mp="30gro1mfkoivi">
                <p data-id="element-58" data-mp="30ghzm3a6ejrx">
                  El siguiente paso no es comprar más productos. Es descubrir
                  qué necesita realmente tu piel.
                </p>
              </Reveal>
              <Reveal delay={0.16} data-id="element-59" data-mp="28q3lq725x7g9">
                <p data-id="element-60" data-mp="2mfxdax51y5to">
                  Cada piel es distinta. La edad, la hidratación, el clima, la
                  sensibilidad y tus hábitos hacen que no exista una rutina
                  universal.
                </p>
              </Reveal>
              <Reveal delay={0.2} data-id="element-61" data-mp="1tybj8vngvnvy">
                <p className="text-ink-700" data-id="element-62" data-mp="1tx9wvv103eyx">
                  Por eso prefiero revisar personalmente tu resultado y ayudarte
                  a elegir una rutina simple, efectiva y adaptada a vos.
                </p>
              </Reveal>
            </div>
          </div>
        </div>

        <Reveal delay={0.1} as="figure" className="mt-20 sm:mt-28" data-id="element-63" data-mp="3u019qy53styr">
          <div className="grain group relative overflow-hidden rounded-[1.75rem] bg-cream sm:rounded-[2.5rem]" data-id="element-64" data-mp="2o9hve5xdyxd">
            <img src={ROUTINE_IMAGE} alt="Rutina de cosmética fresca con frascos de vidrio ámbar y esmerilado, lino y una rama de salvia bajo luz natural suave" className="h-[46vh] w-full object-cover transition-transform duration-[2200ms] ease-out group-hover:scale-[1.04] sm:h-[62vh]" data-id="element-65" data-mp="7lrqf3g16c4u" />
          </div>
          <figcaption className="mt-4 font-sans text-[0.7rem] font-light uppercase tracking-[0.18em] text-ink-400" data-id="element-66" data-mp="3k47rqz8m889l">
            Cosmética fresca · Luz natural · Rutina simple
          </figcaption>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:mt-20 lg:grid-cols-12" data-id="element-67" data-mp="zcpe1t3jj6jg">
          <Reveal className="lg:col-span-7" data-id="element-68" data-mp="2jvi1n5luqh45">
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] bg-sage-100 px-7 py-12 sm:rounded-[2.5rem] sm:px-12 sm:py-16" data-id="element-69" data-mp="2ju84qjqqjez3">
              <div data-id="element-70" data-mp="2b37truyfinq2">
                <p className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-sage-600" data-id="element-71" data-mp="2b2o8c49klh7a">
                  Acompañamiento personal
                </p>
                <h3 className="mt-6 font-serif text-[1.75rem] font-light leading-[1.2] text-ink-900 sm:text-[2.35rem]" data-id="element-72" data-mp="262aatg5lhpni">
                  Quiero mi rutina personalizada
                </h3>
                <p className="mt-6 max-w-md font-sans text-[0.95rem] font-light leading-[1.9] text-ink-700" data-id="element-73" data-mp="1w81mz5riekvo">
                  Revisaré personalmente el resultado de tu Skin Fresh Index™ y
                  te recomendaré una rutina adaptada a las verdaderas
                  necesidades de tu piel.
                </p>
              </div>

              <div className="mt-10" data-id="element-74" data-mp="3hiqhajz68vy8">
                <a href="https://wa.me/5493513830202" target="_blank" rel="noreferrer" className="group inline-flex w-fit items-center gap-3 rounded-full bg-ink-900 px-7 py-4 font-sans text-[0.82rem] font-light tracking-[0.06em] text-warmwhite transition-all duration-500 ease-out hover:bg-sage-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-600 focus-visible:ring-offset-2 focus-visible:ring-offset-sage-100" data-id="element-75" data-mp="3hjtd96bcpol0">
                  <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-76" data-mp="1vg1v70i2j0w4" />
                  Quiero mi rutina personalizada
                  <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-500 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-77" data-mp="1mhq3ev5gtx23" />
                </a>
                <p className="mt-5 font-sans text-[0.7rem] font-light uppercase tracking-[0.18em] text-sage-600" data-id="element-78" data-mp="1cl3kwd0m3i38">
                  Respuesta personalizada · Sin compromiso
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.08} className="lg:col-span-5" data-id="element-79" data-mp="sy0dqu8o7wzc">
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] border border-beige bg-warmwhite px-7 py-10 sm:rounded-[2.5rem] sm:px-10 sm:py-14" data-id="element-80" data-mp="szl8okywdhxq">
              <div data-id="element-81" data-mp="12ttn64r3facw">
                <p className="font-sans text-[0.6rem] font-light uppercase tracking-widest text-ink-400" data-id="element-82" data-mp="12xhhh64d40so">
                  Colección
                </p>
                <h3 className="mt-6 font-serif text-[1.4rem] font-light leading-[1.3] text-ink-900 sm:text-[1.7rem]" data-id="element-83" data-mp="1bwusi384wxfi">
                  ¿Preferís explorar primero?
                </h3>
                <p className="mt-5 font-sans text-[0.9rem] font-light leading-[1.9] text-ink-500" data-id="element-84" data-mp="1llcq6bl4aoex">
                  Conocé toda la colección de cosmética fresca Ringana y
                  descubrí productos formulados con ingredientes frescos y de
                  alta calidad.
                </p>
              </div>

              <a href="https://gabrielasileoni.ringana.lat/todos-los-productos/?lang=es-AR" target="_blank" rel="noreferrer" className="group mt-10 inline-flex w-fit items-center gap-2 border-b border-ink-400/50 pb-1 font-sans text-[0.8rem] font-light tracking-[0.06em] text-ink-700 transition-colors duration-500 ease-out hover:border-sage-600 hover:text-sage-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-600 focus-visible:ring-offset-4 focus-visible:ring-offset-warmwhite" data-id="element-85" data-mp="22obgkyto8nie">
                Explorar la colección Ringana
                <ArrowUpRightIcon className="h-3.5 w-3.5 transition-transform duration-500 ease-out group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-86" data-mp="2v9uw3slb4936" />
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12} data-id="element-87" data-mp="15x9h4wg77mjw">
          <p className="mx-auto mt-16 max-w-md text-center font-serif text-[1.1rem] font-light italic leading-[1.7] text-ink-400 sm:mt-20 sm:text-[1.25rem]" data-id="element-88" data-mp="3j70xkpaekt3k">
            La mejor rutina no es la que tiene más productos. Es la que
            realmente necesita tu piel.
          </p>
        </Reveal>
      </div>
    </section>;
}